import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { App } from "./App";
// Tokenschicht zuerst. Ohne sie sind 27 CSS-Variablen undefiniert, die das
// ui-react-CSS und diese App ohne Fallback benutzen — darunter --brand, --text,
// --card, --border und die zehn --badge-*-Statusfarben. Eine undefinierte
// Variable macht die ganze Deklaration ungueltig, die Werte fielen also aus,
// nicht auf etwas Aehnliches zurueck (am 2026-08-12 im ausgelieferten CSS
// gemessen). Die Tokens lagen bisher nur in den vendorten shared/ui-Kopien,
// die dieses Frontend gar nicht laedt.
//
// Seit dem 30.08.2026 v3 statt v2 (Welle 2 der v3-Einfuehrung). Die alten
// v2-Namen loesen weiter auf: v3/base.css zieht compat/v2-aliases.css am Ende
// selbst mit, ein zweiter Import waere also eine doppelte Quelle. --brand hat
// dabei den WERT gewechselt (#ffb703 -> #f03078), nicht nur den Namen — das
// ist Absicht und der sichtbare Teil der Umstellung.
import "@weretradeit/design-system/v3/base.css";
// design-system 4.2.1: die Szene dieser App fuer GlyphLoader (erster
// Ladebildschirm) und GlyphErrorPage (404, und 500 ueber ErrorBoundary appKey).
// ui-react traegt die Engine NICHT mit; ohne diesen Import bleibt das Feld leer
// und nur der Text steht. Nebeneffekt-Import: registriert `wt-glyphfield` einmal
// (≈ 32 KB). Erst 4.2.1 fuehrt `wt-glyphfield*.js` in `sideEffects` — mit 4.2.0
// warf der Produktionsbau diesen Import still weg.
import "@weretradeit/design-system/v3/glyphfield/wt-glyphfield.shopBeaver.js";
// ui-react 3.x liefert GAR KEIN CSS mehr: `dist` enthaelt keine `.css`, und die
// Komponentenstile sind in das CSS-Paket gewandert (v3/base.css oben). Der
// frueher hier stehende zweite Import — `@weretradeit/ui-react/dist/index.css` —
// laesst sich in 3.x nicht mehr aufloesen und bricht den Bau.
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
